import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { AerialAndScissorLift } from './aerial-and-scissor-lift.model';

export class AerialAndScissorLiftListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string = '';

  /** The location of the equipment */
  location: string = '';

  /** The unit number of the equipment */
  unitNumber: string = '';

  /** The type of equipment being inspected */
  typeOfEquipment: string = '';

  /** The job number associated with the inspection */
  jobNumber: string = '';

  /** The person who performed the inspection */
  inspectedBy: string = '';

  /** Unique identifier for the form */
  id: string = '';

  constructor(data?: Partial<AerialAndScissorLiftListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new AerialAndScissorLiftListItem();
    const fieldMappings = AerialAndScissorLift.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof AerialAndScissorLiftListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): AerialAndScissorLiftListItem {
    return new AerialAndScissorLiftListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      location: data.location,
      unitNumber: data.unitNumber,
      typeOfEquipment: data.typeOfEquipment,
      jobNumber: data.jobNumber,
      inspectedBy: data.inspectedBy
    });
  }
} 